import Progress from './src/index.vue'

export default Progress
